import React from "react";
import Grid from "@material-ui/core/Grid";
import "./PDFs.scss";
import QuotationHeader from "./images/quotation-header.png";
import QuotationFooter from "./images/quotation-footer-hd.png";
import {
  PDFInput,
  QuotationInput,
} from "../../../../components/FormInputs/FormInputs";
import { chargeInputs } from "../../../../utils/Data/dataTexts";
const displayAddress = (addresses) => {
  let address = {
    city: "",
    address: "",
    postcode: "",
    country: "",
    companyname: "",
  };
  if (addresses.length > 0) {
    for (let i in addresses[0]) {
      address[i] = addresses[0][i];
    }
  }
  return address;
};
const addCommas = (num) => {
  if (num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};
function QuotationForm({ ...props }) {
  return (
    <div className='Column'>
      <div
        className='ImportCustomsContainer Column'
        style={{
          height: '1130px',
          position: 'relative',
          alignItems: 'center',
        }}
      >
        <img src={QuotationHeader} alt='' />
        <div className='QuotationContent'>
          <p className='QuotationTitle MarginHorizontal'>Quotation</p>
          <p className='QuotationSubTitle' style={{ marginBottom: '16px' }}>
            Thank you for your request for quotation! Please find our offer
            below.
          </p>
          <Grid container className='MarginHorizontal'>
            <Grid item>
              <PDFInput
                labelStyle={{
                  fontSize: '16px',
                  fontStyle: 'italic',
                  paddingLeft: '0',
                }}
                disabled
                value={props.quotation.reference}
                label='Quotation reference nr:'
              />
              <PDFInput
                labelStyle={{
                  fontSize: '16px',
                  fontStyle: 'italic',
                  paddingLeft: '0',
                }}
                disabled
                value={props.quotation.date}
                label='Quotation date:'
              />
              <PDFInput
                labelStyle={{
                  fontSize: '16px',
                  fontStyle: 'italic',
                  paddingLeft: '0',
                }}
                disabled
                value={props.quotation.validity}
                label='Quotation validity date:'
              />
            </Grid>
          </Grid>
          <div className='Row'>
            <Grid container className='MarginHorizontal'>
              <Grid item xs={2} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic' }}>Customer: </p>
              </Grid>
              <Grid item s={3}>
                <p
                  style={{ marginBottom: 0 }}
                >{`${props.order.contact.firstname} ${props.order.contact.lastname}`}</p>{' '}
                <p style={{ margin: 0 }}>{props.order.contact.companyname}</p>{' '}
                <p style={{ margin: 0 }}>{props.order.contact.email}</p>
                <p style={{ margin: 0 }}>{props.order.contact.phone}</p>
              </Grid>
            </Grid>
            <Grid container className='MarginHorizontal'>
              <Grid item xs={5} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic' }}>Quotation made by: </p>
              </Grid>
              <Grid item s={3}>
                <p
                  style={{ marginBottom: 0 }}
                >{`${props.quotation.firstname} ${props.quotation.lastname}`}</p>
                <p style={{ margin: 0 }}>{props.quotation.companyname}</p>
                <p style={{ margin: 0 }}>{props.quotation.email}</p>
                <p style={{ margin: 0 }}>{props.quotation.phone}</p>
              </Grid>
            </Grid>
          </div>
          <div className='QuotationContentDivider'>
            <p>Cargo Details</p>
          </div>
          <div className='QutotationRow' style={{ marginTop: '16px' }}>
            <div className='RowItemDim' style={{ flex: '3' }}>
              <p>Dimensions (cm):</p>
              <div className='DimItem'>
                <p className='Flex1'>Length (cm)</p>
                <p className='Flex1'>Width (cm)</p>
                <p className='Flex1'>Height (cm)</p>
                {/*   <p className="Flex1">We</p> */}
                <p className='Flex1'>Quantity (pcs)</p>
              </div>
            </div>
            <div className='RowItem'>
              <p>Total Actual Weight (kg)</p>
            </div>
            <div className='RowItem'>
              <p>Total Chargable Weight (kg)</p>
            </div>
            {/*             <div className="RowItem">
              <p>Total Volume in CBM</p>
            </div> */}
          </div>
          {props.order.shipments.map((shipment, i) => {
            return (
              <>
                <div className='QutotationRow'>
                  <div className='RowItem' style={{ flex: '3' }}>
                    <QuotationInput id='length' value={shipment['length']} />
                    <QuotationInput id='width' value={shipment.width} />
                    <QuotationInput id='height' value={shipment.height} />
                    {/* <QuotationInput id="weight" value={shipment.weight} /> */}
                    <QuotationInput id='quantity' value={shipment.quantity} />
                  </div>
                  <div className='RowItem'>
                    <QuotationInput
                      id='actualweight'
                      value={shipment.actualweight}
                    />
                  </div>
                  <div className='RowItem'>
                    <QuotationInput
                      id='chargeableweight'
                      value={shipment.chargeableweight}
                    />
                  </div>
                  {/*                   <div className="RowItem">
                    <QuotationInput
                      id="totalvolume"
                      value={shipment.totalvolume}
                    />
                  </div> */}
                </div>
              </>
            );
          })}
          <div className='QutotationRow'>
            <div className='RowItem'>
              <p style={{ flex: '5' }}>Total:</p>
              <p style={{ flex: '2' }}>
                {`${props.order.shipmentpcs} pcs` || '0'}
              </p>
              <p style={{ flex: '2' }}>
                {`${props.order.shipmentweight} kg` || '0'}
              </p>
              <p style={{ flex: '2' }}>
                {`${props.order.shipmentchargeableweight} kg` || '0'}
              </p>
              {/*               <p style={{ flex: "2" }}>
                {`${props.order.shipmentvolume}` || "0"}
              </p> */}
            </div>
          </div>
          <div className='QuotationContentDivider'>
            <p style={{ width: '150px' }}>Service Information</p>
          </div>
          <div className='Row'>
            <Grid
              container
              className='MarginHorizontal QuotationServiceInfo'
              style={{ borderRight: '4px solid white' }}
            >
              <Grid item xs={5} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic', marginBottom: 0 }}>
                  Origin Airport:{' '}
                </p>
              </Grid>
              <Grid item xs={6}>
                <p style={{ marginBottom: 0 }}>{props.order.origin}</p>
              </Grid>
              <Grid item xs={5} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic', margin: 0 }}>
                  Shippers Address:
                </p>
              </Grid>
              <Grid container xs={6}>
                <Grid item xs={12}>
                  <p style={{ margin: 0 }}>
                    {`${displayAddress(props.order.shipperaddresses).city} ${
                      displayAddress(props.order.shipperaddresses).postcode
                    }`}
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <p style={{ margin: 0 }}>
                    {`${displayAddress(props.order.shipperaddresses).address}`}
                  </p>
                </Grid>
              </Grid>
              <Grid item xs={5} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic', marginBottom: 0 }}>
                  Pickup from shipper to airport:
                </p>
              </Grid>
              <Grid item xs={6}>
                <p style={{ marginBottom: 0 }}>
                  {props.order.pickup ? 'Yes' : 'No'}
                </p>
              </Grid>
            </Grid>
            <Grid
              container
              className='MarginHorizontal QuotationServiceInfo'
              style={{ borderLeft: '4px solid white' }}
            >
              <Grid item xs={5} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic', marginBottom: 0 }}>
                  Destination airport:
                </p>
              </Grid>
              <Grid item xs={6}>
                <p style={{ marginBottom: 0 }}>{props.order.destination}</p>
              </Grid>
              <Grid item xs={5} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic', margin: 0 }}>
                  Consignee Address:
                </p>
              </Grid>
              <Grid container xs={6}>
                <Grid item xs={12}>
                  <p style={{ margin: 0 }}>
                    {`${displayAddress(props.order.consigneeaddresses).city} ${
                      displayAddress(props.order.consigneeaddresses).postcode
                    }`}
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <p style={{ margin: 0 }}>
                    {`${
                      displayAddress(props.order.consigneeaddresses).address
                    }`}
                  </p>
                </Grid>
              </Grid>
              <Grid item xs={5} style={{ marginRight: '16px' }}>
                <p style={{ fontStyle: 'italic', marginBottom: 0 }}>
                  Delivery to consignee address:
                </p>
              </Grid>
              <Grid item xs={6}>
                <p style={{ marginBottom: 0 }}>
                  {props.order.delivery ? 'Yes' : 'No'}
                </p>
              </Grid>
            </Grid>
          </div>
          <div className='RowItem' style={{ height: '30px' }}>
            <PDFInput
              label='Estimated total transit time'
              labelStyle={{
                paddingLeft: '0',
                fontSize: '16px',
                fontStyle: 'italic',
              }}
              value={props.quotation.transittime}
            />
          </div>
        </div>
      </div>
      <div
        className='ImportCustomsContainer Column'
        style={{
          height: '1150px',
          position: 'relative',
          alignItems: 'center',
        }}
      >
        <img src={QuotationHeader} alt='' />
        <div className='QuotationContent'>
          <div className='QutotationRow'>
            <div
              className='QuotationContentDivider'
              style={{ marginBottom: '16px' }}
            >
              <p>Origin Charges</p>
            </div>
          </div>
          {props.quotation.origincharges.map((item, i) => {
            let firstRow = [];
            let secondRow = [];
            chargeInputs.forEach((input, index) => {
              if (input.id !== 'carrier' && input.id !== 'density') {
                firstRow.push(
                  <div
                    className='RowItem'
                    style={{ flex: input.id === 'chargename' ? '2' : '1' }}
                  >
                    <p className='QuotationChargeLabels'>{input.label}</p>
                  </div>
                );
                secondRow.push(
                  <div
                    className='RowItem'
                    style={{ flex: input.id === 'chargename' ? '2' : '1' }}
                  >
                    <QuotationInput
                      disabled
                      number={input.id === 'total' ? true : false}
                      id={input.id}
                      value={item[input.id]}
                    />
                  </div>
                );
              }
            });
            return i === 0 ? (
              <>
                <div className='QutotationRow'>{firstRow}</div>
                <div className='QutotationRow'>{secondRow}</div>
              </>
            ) : (
              <div className='QutotationRow'>{secondRow}</div>
            );
          })}
          <div className='QutotationRow'>
            <div className='RowItem'>
              <p
                style={{ flex: '5', fontWeight: 'normal' }}
              >{`Total Origin Charges: (${props.quotation.origincharges[0].currency})`}</p>
              <p style={{ flex: '1' }}>
                <span
                  style={{
                    /* float: "right", */
                    marginLeft: '10px',
                    color: 'black',
                    fontWeight: 'normal',
                  }}
                >
                  {`${addCommas(props.quotation.totalorigincharges)}`}
                </span>
              </p>
            </div>
          </div>
          <div className='QutotationRow'>
            <div
              className='QuotationContentDivider'
              style={{ marginBottom: '16px' }}
            >
              <p style={{ width: '120px' }}>Freight Charges</p>
            </div>
          </div>
          {props.quotation.freightcharges.map((item, i) => {
            let firstRow = [];
            let secondRow = [];
            chargeInputs.forEach((input, index) => {
              if (input.id !== 'density') {
                firstRow.push(
                  <div
                    className='RowItem'
                    style={{ flex: input.id === 'chargename' ? '2' : '1' }}
                  >
                    <p className='QuotationChargeLabels'>{input.label}</p>
                  </div>
                );
                secondRow.push(
                  <div
                    className='RowItem'
                    style={{ flex: input.id === 'chargename' ? '2' : '1' }}
                  >
                    <QuotationInput
                      disabled
                      number={input.id === 'total' ? true : false}
                      id={input.id}
                      value={item[input.id]}
                    />
                  </div>
                );
              }
            });
            return i === 0 ? (
              <>
                <div className='QutotationRow'>{firstRow}</div>
                <div className='QutotationRow'>{secondRow}</div>
              </>
            ) : (
              <div className='QutotationRow'>{secondRow}</div>
            );
          })}
          <div className='QutotationRow'>
            <div className='RowItem'>
              <p
                style={{ flex: '6', fontWeight: 'normal' }}
              >{`Total Freight Charges: (${props.quotation.freightcharges[0].currency})`}</p>
              <p style={{ flex: '1' }}>
                <span
                  style={{
                    /* float: "right", */
                    marginLeft: '10px',
                    color: 'black',
                    fontWeight: 'normal',
                  }}
                >
                  {`${addCommas(props.quotation.totalfreightcharges)}`}
                </span>
              </p>
            </div>
          </div>
          <div className='QutotationRow'>
            <div
              className='QuotationContentDivider'
              style={{ marginBottom: '16px' }}
            >
              <p style={{ width: '150px' }}>Destination Charges</p>
            </div>
          </div>
          {props.quotation.destinationcharges.map((item, i) => {
            let firstRow = [];
            let secondRow = [];
            chargeInputs.forEach((input, index) => {
              if (input.id !== 'carrier' && input.id !== 'density') {
                firstRow.push(
                  <div
                    className='RowItem'
                    style={{ flex: input.id === 'chargename' ? '2' : '1' }}
                  >
                    <p className='QuotationChargeLabels'>{input.label}</p>
                  </div>
                );
                secondRow.push(
                  <div
                    className='RowItem'
                    style={{ flex: input.id === 'chargename' ? '2' : '1' }}
                  >
                    <QuotationInput
                      disabled
                      number={input.id === 'total' ? true : false}
                      id={input.id}
                      value={item[input.id]}
                    />
                  </div>
                );
              }
            });
            return i === 0 ? (
              <>
                <div className='QutotationRow'>{firstRow}</div>
                <div className='QutotationRow'>{secondRow}</div>
              </>
            ) : (
              <div className='QutotationRow'>{secondRow}</div>
            );
          })}
          <div className='QutotationRow'>
            <div className='RowItem'>
              <p
                style={{ flex: '5', fontWeight: 'normal' }}
              >{`Total Destination Charges: (${props.quotation.destinationcharges[0].currency})`}</p>
              <p style={{ flex: '1' }}>
                <span
                  style={{
                    /* float: "right", */
                    marginLeft: '10px',
                    color: 'black',
                    fontWeight: 'normal',
                  }}
                >
                  {`${addCommas(props.quotation.totaldestinationcharges)}`}
                </span>
              </p>
            </div>
          </div>
          <div className='QutotationRow'>
            <div
              className='QuotationContentDivider'
              style={{ marginBottom: '16px' }}
            ></div>
          </div>
          <div className='QutotationRow'>
            <div className='RowDivider'>
              <p className='TotalQuotationChargesLabel' style={{ flex: '3' }}>
                Total Quotation Charges
              </p>
              <p className='TotalQuotationChargesLabel' style={{ flex: '1' }}>
                Currency
              </p>
              <p className='TotalQuotationChargesLabel' style={{ flex: '2' }}>
                Price
              </p>
            </div>
          </div>
          <div className='QutotationRow'>
            <div className='RowItem Total' style={{ flex: 3 }}>
              <p className='QuotationChargeLabels'>Total Origin Charges</p>
            </div>
            <div className='RowItem Total'>
              <p>{`${props.quotation.origincharges[0].currency}`}</p>
            </div>
            <div className='RowItem Total' style={{ flex: 2 }}>
              <p>{addCommas(props.quotation.totalorigincharges)}</p>
            </div>
          </div>
          <div className='QutotationRow'>
            <div className='RowItem Total' style={{ flex: 3 }}>
              <p className='QuotationChargeLabels'>Total Freight Charges</p>
            </div>
            <div className='RowItem Total'>
              <p>{`${props.quotation.freightcharges[0].currency}`}</p>
            </div>
            <div className='RowItem Total' style={{ flex: 2 }}>
              <p>{addCommas(props.quotation.totalfreightcharges)}</p>
            </div>
          </div>
          <div className='QutotationRow'>
            <div className='RowItem Total' style={{ flex: 3 }}>
              <p className='QuotationChargeLabels'>Total Destination Charges</p>
            </div>
            <div className='RowItem Total'>
              <p>{`${props.quotation.destinationcharges[0].currency}`}</p>
            </div>
            <div className='RowItem Total' style={{ flex: 2 }}>
              <p>{addCommas(props.quotation.totaldestinationcharges)}</p>
            </div>
          </div>
          <div className='QutotationRow'>
            <div className='RowDivider' style={{ height: '20px' }}></div>
          </div>
          <div className='QutotationRow'>
            <div className='RowItem OrangeBg' style={{ flex: 3 }}>
              <p>TOTAL</p>
            </div>
            <div className='RowItem OrangeBg'>
              <QuotationInput
                disabled
                className='QuotationInputOrange'
                value={props.quotation.currency || ''}
              />
            </div>
            <div className='RowItem OrangeBg' style={{ flex: 2 }}>
              <QuotationInput
                disabled
                number={true}
                id='totalcharges'
                placeholder='Total Price'
                className='QuotationInputOrange'
                value={props.quotation.totalcharges}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className='ImportCustomsContainer Column'
        style={{
          height: '1100px',
          position: 'relative',
          alignItems: 'center',
        }}
      >
        <div className='QuotationContent'>
          {props.quotation.notes.length > 0 ? (
            <div className='QutotationRow' style={{ height: '65px' }}>
              <div
                className='QuotationContentDivider'
                style={{ marginBottom: '16px' }}
              >
                <p style={{ width: '65px' }}>Notes</p>
                <ol style={{ marginTop: '30px' }}>
                  {props.quotation.notes.map((note) => {
                    return <li>{note}</li>;
                  })}
                </ol>
              </div>
            </div>
          ) : null}
          <div className='QutotationRow'>
            <div
              className='QuotationContentDivider'
              style={{ marginBottom: '16px' }}
            >
              <p style={{ width: '120px' }}>Other Charges</p>
            </div>
          </div>
          {props.quotation.othercharges.map((item) => {
            return (
              <li className='QuotationChargeLabels'>
                <span style={{ fontWeight: 'bold' }}>{item.label}: </span>
                {`${item.content}`}
              </li>
            );
          })}
          <div className='QutotationRow'>
            <div
              className='QuotationContentDivider'
              style={{ marginBottom: '16px' }}
            >
              <p style={{ width: '120px' }}>Important Notes</p>
            </div>
          </div>
          {props.quotation.importantnotes.map((item) => {
            return <li className='QuotationChargeLabels'>{item.content}</li>;
          })}
          <div className='QutotationRow'>
            <div
              className='QuotationContentDivider'
              style={{ marginBottom: '16px' }}
            >
              <p style={{ width: '65px' }}>Remarks</p>
            </div>
          </div>
          {props.quotation.remarks.map((item) => {
            return <li className='QuotationChargeLabels'>{item.content}</li>;
          })}
        </div>
        <div
          style={{
            position: 'absolute',
            bottom: '0',
            textAlign: 'center',
          }}
        >
          <img src={QuotationFooter} alt='src' />
        </div>
      </div>
    </div>
  );
}

export default QuotationForm;
